module.exports = __webpack_public_path__ + "img/email.e3fac49f.svg";